document.addEventListener( 'DOMContentLoaded', function () {
  function getPosition(element) {
    var clientRect = element.getBoundingClientRect();
    return {left: clientRect.left + document.documentElement.scrollLeft,
            top: clientRect.top + document.documentElement.scrollTop};
  }
  function document_click(e) {
    if (e.target.classList.contains('summary-rating') || e.target.closest('.summary-rating')) {
      var header_height = document.querySelector('.site-header-sticky .site-header').offsetHeight;
      var reviews_pos = getPosition(document.querySelector('.stamped-content')).top;
      var scroll_to = reviews_pos - header_height;
      setTimeout(function(){
        window.scrollTo({top: scroll_to,behavior: "smooth"});
      },500);
    }
  }
  document.addEventListener('click',document_click,false);

  var current_slide_index = 0;
  function scroll_product_image_slider(e) {
    if (e.target.classList.contains('product-custom-slider--btn')) {
      e.preventDefault();
      var slider_container = e.target.closest('.product-custom-slider').querySelector('.product-custom-slider--container');
      var slider_list = e.target.closest('.product-custom-slider').querySelector('.product-custom-slider--list');
      var slide_width = 123;
      var slider_width = slider_container.offsetWidth - 12;
      var total_slides_number = slider_list.querySelectorAll('.product-gallery--media-thumbnail').length;
      var total_slides_width = slide_width * total_slides_number;
      if (e.target.classList.contains('product-custom-slider--btn-right')) {
        if ((total_slides_width - slider_width - (slide_width * current_slide_index)) >= slide_width) {
          var slider_list_pos = slide_width * (current_slide_index + 1);
          current_slide_index++;
        } else {
          var slider_list_pos = total_slides_width - slider_width - 12;
        }
        slider_list.style.transform = "translate(-" + slider_list_pos + "px,0)";
      }
      if (e.target.classList.contains('product-custom-slider--btn-left')) {
        if (current_slide_index > 0) {
          current_slide_index--;
          var slider_list_pos = slide_width * current_slide_index;
          slider_list.style.transform = "translate(-" + slider_list_pos + "px,0)";
        }
      }
    }
  }
  function switch_main_slider_by_second(e) {
    if (e.target.classList.contains('product-gallery--media-thumbnail') && e.target.closest('.product-custom-slider--list')) {
      var selected_nav_slide = document.querySelector('.product-custom-slider .product-gallery--media-thumbnail[data-gallery-selected="true"]');
      if (selected_nav_slide) {
        selected_nav_slide.setAttribute('data-gallery-selected','false');
      }
      e.target.setAttribute('data-gallery-selected','true');
      var current_data_media = e.target.getAttribute('data-media');
      var new_selected_slide = document.querySelector('figure[data-media="' + current_data_media + '"]');
      if (new_selected_slide) {
        var selected_slide = document.querySelector('figure[aria-hidden="false"][data-gallery-selected="true"]');
        if (selected_slide) {
          selected_slide.setAttribute('aria-hidden','true');
          selected_slide.setAttribute('data-gallery-selected','false');
        }
        new_selected_slide.setAttribute('aria-hidden','false');
        new_selected_slide.setAttribute('data-gallery-selected','true');
      }
      if (document.querySelector('.product-gallery--navigation .product-gallery--media-thumbnail[data-media="' + current_data_media + '"]')) {
        document.querySelector('.product-gallery--navigation .product-gallery--media-thumbnail[data-media="' + current_data_media + '"]').click();
      }
    }
    if (e.target.classList.contains('product-gallery--media-thumbnail-img') && e.target.closest('.product-zoom--thumb-scroller')) {
      console.log('click on zoom nav');
      var current_data_media = e.target.closest('.product-gallery--media-thumbnail').getAttribute('data-media');
      document.querySelector('.product-custom-slider .product-gallery--media-thumbnail[data-media="' + current_data_media + '"]').click();
    }
  }
  document.addEventListener('click',scroll_product_image_slider);
  document.addEventListener('click',switch_main_slider_by_second);
});


document.addEventListener('DOMContentLoaded', function () {
  const bannerSlider = document.querySelector('.global-banner-slider');
  if (bannerSlider) {
    new Swiper(bannerSlider, {
      loop: true,
      autoplay: {
        delay: 5000,
      },
      pagination: {
        el: bannerSlider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: bannerSlider.querySelector('.swiper-button-next'),
        prevEl: bannerSlider.querySelector('.swiper-button-prev'),
      }
    });
  }
});